export default "__VITE_ASSET__61520f43__"